import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'custom-calendar',
  templateUrl: './custom-calendar.component.html'
})
export class CustomCalendarComponent {
  value?: any;

  @Input()
  set ngValue(value: any) {
    this.value = value;
    this.ngValueChange.emit(this.value);
  }

  @Output()
  ngValueChange = new EventEmitter<any>();

  get ngValue() {
    return this.value;
  }
}
